import { Component, inject, OnInit } from '@angular/core'
import { PageComponent } from '@client/Components/ui/Page/Page.Component'
import Order, { STATUS_CONFIRMED, STATUS_PENDING } from '@client/Order'
import { LoaderComponent } from '@ui/Components/Loader/Loader.Component'
import { ActivatedRoute, Params } from '@angular/router'
import { OrdersService } from '@client/Services/OrdersService'
import HttpError from '@ui/HttpError'
import { CardComponent } from '@ui/Components/Card/Card.Component'
import { CardContentComponent } from '@ui/Components/Card/CardContent.Component'
import { BaseCurrencyComponent } from '@ui/Components/Currency/BaseCurrency.Component'
import { SystemConfigService } from '@client/Services/SystemConfigService'
import { NgStyle } from '@angular/common'
import { OrderTabViewComponent } from '@client/Components/Orders/Order/OrderTabView.Component'

@Component({
	selector: 'order',
	templateUrl: './Order.Component.html',
	imports: [
		PageComponent,
		LoaderComponent,
		CardComponent,
		CardContentComponent,
		BaseCurrencyComponent,
		NgStyle,
		OrderTabViewComponent,
		PageComponent,
	],
})
export class OrderComponent implements OnInit {
	protected readonly STATUS_PENDING = STATUS_PENDING

	protected readonly STATUS_CONFIRMED = STATUS_CONFIRMED

	protected order: Order

	protected orderStatus: string = ''

	protected statusColour: string = '#000000'

	protected readonly systemConfigService: SystemConfigService

	private readonly route: ActivatedRoute

	private readonly ordersService: OrdersService

	constructor() {
		this.route = inject(ActivatedRoute)
		this.ordersService = inject(OrdersService)
		this.systemConfigService = inject(SystemConfigService)
	}

	public ngOnInit() {
		this.route.params.subscribe(async (params: Params): Promise<void> => {
			await this.fetchOrder(params.id)
		})
	}

	private readonly fetchOrder = async (id: number) => {
		try {
			this.order = await this.ordersService.findById(id)

			this.orderStatus = this.order.getStatus()

			this.statusColour = this.order.getStatusColour()
		} catch (error) {
			if (!(error instanceof HttpError)) {
				throw error
			}
		}
	}
}
